import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import SplashScreen from './components/splash/SplashScreen';
import PageShell from './components/layout/PageShell/PageShell';
import DynamicPage from './components/pages/DynamicPage/DynamicPage';
import { getHomePage } from './contentful/queries';

function App() {
  const [isSplashDone, setIsSplashDone] = useState(false);
  const [isHidingSplash, setIsHidingSplash] = useState(false);
  const [initialLoaded, setInitialLoaded] = useState(false);
  const [initialHomeData, setInitialHomeData] = useState(null);
  const [initialError, setInitialError] = useState(null);

  // When min time and data loaded: fade splash
  useEffect(() => {
    let isMounted = true;
    let minTimer;
    let hideTimer;
    let minElapsed = false;

    // Minimum 1000ms
    minTimer = setTimeout(() => {
      minElapsed = true;
      // If data loaded too, fade splash
      if (initialLoaded) triggerFade();
    }, 1000);

    // Fetch home page
    (async () => {
      try {
        const homeData = await getHomePage();
        if (isMounted) setInitialHomeData(homeData);
      } catch (err) {
        if (isMounted) setInitialError(err);
      } finally {
        if (isMounted) setInitialLoaded(true);
        // If min time is done, fade splash
        if (minElapsed) triggerFade();
      }
    })();

    function triggerFade() {
      // Show fade-out
      setIsHidingSplash(true);
      hideTimer = setTimeout(() => setIsSplashDone(true), 600);
    }

    return () => {
      isMounted = false;
      clearTimeout(minTimer);
      clearTimeout(hideTimer);
    };
  }, [initialLoaded]);

  const showSplash = !isSplashDone;

  return (
    <>
      {showSplash && <SplashScreen hiding={isHidingSplash} />}
      {!showSplash && (
        <Router>
          <PageShell>
            <Routes>
              <Route
                path="/"
                element={<DynamicPage initialHomeData={initialHomeData} initialError={initialError} />}
              />
              <Route path="*" element={<DynamicPage />} />
            </Routes>
          </PageShell>
        </Router>
      )}
    </>
  );
}

export default App;
